import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    quoteAcceptedDescription: 'Turn this quote into an invoice now or later',
    quoteAcceptedTitle: 'The quote was approved',
    quoteArchivedDescription: 'Archive this quote',
    quoteArchivedTitle: 'The quote was declined',
    quoteRevisedDescription: 'Duplicate this quote and edit it',
    quoteRevisedTitle: 'Edit the quote',
  },
  fr: {
    quoteAcceptedDescription:
      'Transformer en facture maintenant ou le faire plus tard',
    quoteAcceptedTitle: 'Le devis a été accepté',
    quoteArchivedDescription: 'Archiver le devis',
    quoteArchivedTitle: 'Le devis a été refusé',
    quoteRevisedDescription: 'Dupliquer et lui apporter des modifications',
    quoteRevisedTitle: 'Le devis doit être corrigé',
  },
} as const);
